export const colors = {
  inactive: "#E35435",
  active: "#0A2AAB",
}